import { spaceClient } from './client';

export const getCustomBoothItemTypes = () =>
  spaceClient.get('/cms/custom-booth-item-types').then((r) => r.data);

export const getCustomBoothItemById = (boothId, id) =>
  spaceClient.get(`/booth/${boothId}/custom-item/${id}`).then((r) => r.data);

export const createCustomBoothItem = (boothId, dto) =>
  spaceClient.post(`/booth/${boothId}/custom-item`, dto).then((r) => r.data);

export const updateCustomBoothItem = (boothId, id, dto) =>
  spaceClient.put(`/booth/${boothId}/custom-item/${id}`, dto).then((r) => r.data);

export const deleteCustomBoothItemFromBooth = (boothId, id) =>
  spaceClient.delete(`/booth/${boothId}/custom-item/${id}`).then((r) => r.data);

export const convertCustomToPortal = (boothId, id, dto) =>
  spaceClient.post(`/booth/${boothId}/custom-item/${id}/convert-to-portal`, dto).then((r) => r.data);

export const convertCustomToMedia = (boothId, id, dto) =>
  spaceClient.post(`/booth/${boothId}/custom-item/${id}/convert-to-media`, dto).then((r) => r.data);
